import { Box, Button, Modal, Radio, Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { Input, AlertLabel } from '../../../assets/styled/Element';
import Success from '../../Modal/Approve/Success';
import { makeStyles } from '@material-ui/core/styles';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { useHistory } from 'react-router-dom';
import Axios from 'axios';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));
function ApprovePtoGSB(props) {
   const history = useHistory();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const classes = useStyles();
   const [radioValue, setRadioValue] = useState('');
   const [showModal, setShowModal] = useState(false);
   const [isLoading, setIsLoading] = useState(true);
   const walletType = 1; // P->P and P->GSB

   const { register, errors, handleSubmit, setValue, getValues } = useForm({
      defaultValues: {
         approveDateCount: 1,
      },
   });

   useEffect(() => {
      getData();
   }, []);

   const getData = () => {
      Axios.get(
         `/GSB/dashboard/config/GetWalletConfig?walletType=${walletType}`,
      )
         .then((response) => {
            setRadioValue(response.data.configs[0].value ? 'a' : 'b');
            setValue('approveDateCount', response.data.configs[1].value);
         })
         .catch((e) => {
            console.log(e);
         });
   };

   const onSubmit = () => {
      /** force set appriveDateCount to 0 when user filled "" or input < 0 */
      if (
         getValues('approveDateCount') == '' ||
         getValues('approveDateCount') < 0
      ) {
         setValue('approveDateCount', 0);
      }
      Axios.post('/GSB/dashboard/config/EditWalletConfig', {
         WalletSkipApprove: radioValue === 'a' ? true : false,
         AutoApproveDay: getValues('approveDateCount'),
         WalletType: walletType,
      })
         .then(() => {
            setShowModal(true);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         });
   };

   const refreshData = () => {
      getData();
      setShowModal(false);
   };
   return (
      <React.Fragment>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>
               <Success
                  onSuccess={() => refreshData()}
                  onClickClose={() => setShowModal(false)}
               />
            </React.Fragment>
         </Modal>
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box width={1}>
               <Box display={'flex'} alignItems={'center'}>
                  <Radio
                     checked={radioValue === 'a'}
                     onChange={(e) => setRadioValue(e.target.value)}
                     value='a'
                     name='radio-button-demo'
                     inputProps={{ 'aria-label': 'A' }}
                  />
                  <Typography>โอนคะแนนโดยไม่ผ่านวันอนุมัติ</Typography>
               </Box>
               <Box display={'flex'} alignItems={'center'}>
                  <Radio
                     checked={radioValue === 'b'}
                     onChange={(e) => setRadioValue(e.target.value)}
                     value='b'
                     name='radio-button-demo'
                     inputProps={{ 'aria-label': 'B' }}
                  />
                  <Typography>กำหนดวัน Approve</Typography>
                  <Input
                     disabled={radioValue !== 'b'}
                     width={'200px'}
                     margin={'0.5rem'}
                     name='approveDateCount'
                     type='number'
                     ref={register({
                        required: {
                           value: radioValue === 'b',
                           message: 'กรุณากรอกข้อมูล',
                        },
                        min: {
                           value: radioValue === 'b' ? 1 : undefined,
                           message: 'จำนวนวันต้องมากกว่า 0 วัน',
                        },
                     })}
                  />
                  <Typography>วัน</Typography>
               </Box>
               <Box
                  style={{
                     'margin-left': '150px',
                     height: 15,
                     width: 200,
                     lineHeight: '0.2',
                  }}
               >
                  {radioValue === 'b' && errors.approveDateCount && (
                     <AlertLabel>{errors.approveDateCount.message}</AlertLabel>
                  )}
               </Box>
            </Box>
            <Button variant={'contained'} color={'primary'} type={'submit'}>
               บันทึก
            </Button>
         </form>
      </React.Fragment>
   );
}

export default ApprovePtoGSB;
